import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { SearchProvider } from './contexts/SearchContext';
import { useAuth } from './contexts/AuthContext';
import HomePage from './pages/HomePage';

import AdvisorPortal from './pages/AdvisorPortal';
import AdvisorBillingSettings from './pages/AdvisorBillingSettings';
import AdvisorSettings from './pages/AdvisorSettings';
import AdvisorTestimonialsPage from './pages/AdvisorTestimonialsPage';
import TestimonialSubmit from './pages/TestimonialSubmit';
import AdvisorLeads from './pages/AdvisorLeads';
import AdvisorProfile from './pages/AdvisorProfile';
import AdvisorResults from './pages/AdvisorResults';
import AdvisorBrowse from './pages/AdvisorBrowse';
import AdminDashboard from './pages/AdminDashboard';
import AdminApplications from './pages/AdminApplications';
import AdminAdvisors from './pages/AdminAdvisors';
import AdminBusinessOwners from './pages/AdminBusinessOwners';
import AdminSubscriptions from './pages/AdminSubscriptions';
import AdminSettings from './pages/AdminSettings';
import AdminGuidedQuestions from './pages/AdminGuidedQuestions';
import NotFound from './pages/NotFound';
import SignInPage from './pages/SignInPage';
import SignUpPage from './pages/SignUpPage';
import GetStarted from './pages/GetStarted';
import Onboarding from './pages/Onboarding';
import BecomeAnAdvisor from './pages/BecomeAnAdvisor';
import { PrivacyPage, TermsPage, ContactPage } from './pages/LegalPages';
import ProtectedRoute from './components/ProtectedRoute';
import ViystrVideo from './pages/ViystrVideo';

function HomeEntry() {
  const { user, isLoading } = useAuth();
  if (!isLoading && user?.role === 'admin') return <Navigate to="/admin" replace />;
  if (!isLoading && user?.role === 'advisor') return <Navigate to="/advisor-portal" replace />;
  return <HomePage />;
}

function App() {
  return (
    <Router>
      <SearchProvider>
        <Routes>
          <Route path="/" element={<HomeEntry />} />
          <Route path="/video" element={<ViystrVideo />} />
          <Route path="/login/*" element={<SignInPage />} />
          <Route path="/sign-in/*" element={<SignInPage />} />
          <Route path="/sign-up/*" element={<SignUpPage />} />
          <Route path="/get-started" element={<GetStarted />} />
          <Route path="/become-an-advisor" element={<BecomeAnAdvisor />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/browse" element={<AdvisorBrowse />} />
          <Route path="/advisors/:category" element={<AdvisorResults />} />
          <Route path="/advisor-portal" element={<Navigate to="/advisor/dashboard" replace />} />
          <Route
            path="/advisor/dashboard"
            element={
              <ProtectedRoute requiredRole="advisor">
                <AdvisorPortal />
              </ProtectedRoute>
            }
          />
          <Route
            path="/advisor/edit-profile"
            element={
              <ProtectedRoute requiredRole="advisor">
              <Onboarding />
              </ProtectedRoute>
            }
          />
          <Route
            path="/advisor/billing"
            element={
              <ProtectedRoute requiredRole="advisor">
                <AdvisorBillingSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/advisor/settings"
            element={
              <ProtectedRoute requiredRole="advisor">
                <AdvisorSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/advisor/testimonials"
            element={
              <ProtectedRoute requiredRole="advisor">
                <AdvisorTestimonialsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/advisor/leads"
            element={
              <ProtectedRoute requiredRole="advisor">
                <AdvisorLeads />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/applications"
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminApplications />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/advisors"
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminAdvisors />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/business-owners"
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminBusinessOwners />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/subscriptions"
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminSubscriptions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/questions"
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminGuidedQuestions />
              </ProtectedRoute>
            }
          />
          <Route path="/testimonial/:token" element={<TestimonialSubmit />} />
          <Route path="/advisor/:slug" element={<AdvisorProfile />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </SearchProvider>
    </Router>
  );
}

export default App;
